/**
 * Fake macOS Menu Bar
 *
 * A decorative menu bar that mimics macOS with:
 * - Random emoji instead of Apple logo
 * - Jam SQL Studio menu items
 * - Real date/time display
 */

import { useState, useEffect } from 'react';
import { PRODUCT_NAME } from '../browserModeUtils';

const MENU_ITEMS = [PRODUCT_NAME, 'File', 'Edit', 'View', 'Query', 'Tools', 'Help'];

// Random emojis for the "Apple" logo - database/coding themed
const EMOJI_OPTIONS = ['🗄️', '💾', '🔮', '⚡', '🎲', '🧊', '💎', '🔷', '🎯', '🚀'];

function getRandomEmoji(): string {
  return EMOJI_OPTIONS[Math.floor(Math.random() * EMOJI_OPTIONS.length)];
}

function formatTime(date: Date): string {
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

function formatDate(date: Date): string {
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

export function FakeMenuBar() {
  const [emoji] = useState(() => getRandomEmoji());
  const [currentTime, setCurrentTime] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fake-menubar">
      {/* Left side - emoji logo and menus */}
      <div className="fake-menubar-left">
        <span className="fake-menubar-logo">{emoji}</span>
        {MENU_ITEMS.map((item) => (
          <span key={item} className="fake-menubar-item">
            {item}
          </span>
        ))}
      </div>

      {/* Right side - system tray area */}
      <div className="fake-menubar-right">
        <span className="fake-menubar-date">
          {formatDate(currentTime)}
        </span>
        <span className="fake-menubar-time">
          {formatTime(currentTime)}
        </span>
      </div>
    </div>
  );
}
